import React from 'react';
import { useTranslate } from 'react-admin';
import {
  Box,
  Typography,
  Grid,
  Paper,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { WidgetType } from 'types/dashboard.ui';
import { WidgetTypeInfo } from './widget.types.config';

interface WidgetTypeSelectionProps {
  widgetTypes: WidgetTypeInfo[];
  selectedType?: WidgetType;
  onTypeSelect: (type: WidgetType) => void;
}

/**
 * Компонент для выбора типа виджета (Шаг 1)
 */
const WidgetTypeSelection: React.FC<WidgetTypeSelectionProps> = ({
  widgetTypes,
  selectedType,
  onTypeSelect,
}) => {
  const translate = useTranslate();

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {translate('resources.dashboards.widget_wizard.select_widget_type')}
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
        {translate('resources.dashboards.widget_wizard.select_widget_type_hint')}
      </Typography>

      <Grid container spacing={2}>
        {widgetTypes.map((type) => (
          <Grid item xs={12} sm={6} md={4} key={type.type}>
            <Paper
              elevation={selectedType === type.type ? 4 : 1}
              sx={{
                p: 3,
                cursor: 'pointer',
                border: selectedType === type.type ? 2 : 1,
                borderColor: selectedType === type.type ? 'primary.main' : 'divider',
                position: 'relative',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  elevation: 3,
                  transform: 'translateY(-2px)',
                },
                minHeight: '140px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
              onClick={() => onTypeSelect(type.type)}
            >
              {selectedType === type.type && (
                <Box 
                  sx={{ 
                    position: 'absolute', 
                    top: 8, 
                    right: 8,
                    bgcolor: 'primary.main',
                    borderRadius: '50%',
                    p: 0.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <CheckIcon sx={{ color: 'white', fontSize: 18 }} />
                </Box>
              )}
              
              <Box sx={{ fontSize: '48px', color: 'primary.main', mb: 2 }}>
                {type.icon}
              </Box>
              
              <Typography variant="h6" gutterBottom>
                {type.name}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {type.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WidgetTypeSelection;
